/**
 * Helper function to extract error message from API response
 * Handles various error formats from axios and API responses
 * Includes status code at the front of the message when available
 */
export function extractErrorMessage(err: any): string {
    const statusCode = err?.response?.status;
    let message = '';

    // Try to get Message from response body
    if (err?.response?.data?.Message) {
        message = err.response.data.Message;
    } else if (err?.response?.data?.message) {
        message = err.response.data.message;
    } else if (err?.response?.status && err?.response?.statusText) {
        message = err.response.statusText;
    } else if (err instanceof Error) {
        message = err.message;
    } else {
        message = 'API request failed';
    }

    // Prepend status code if available
    if (statusCode) {
        return `${statusCode}: ${message}`;
    }

    return message;
}

